/*** IMPORTS FROM imports-loader ***/
var define = false;

var MediaQueryDispatch = require('./MediaQueryDispatch');
module.exports = new MediaQueryDispatch();




//////////////////
// WEBPACK FOOTER
// ./node_modules/enquire.js/src/index.js
// module id = 561
// module chunks = 0